import React, {useMemo} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {Header} from './components/Header';
import {HomePage} from './pages/HomePage';
import {PadPage} from './pages/PadPage';
import {Page404} from './pages/Page404';
import {Fonts, MuiScheme} from './utils/colors';
import {useSystemColorScheme} from './utils/colorScheme';

const App = () => {
  const scheme = useSystemColorScheme();
  const theme = useMemo(() => {
    const palette = MuiScheme[scheme];
    return createMuiTheme({
      palette: {
        type: scheme,
        primary: {
          main: palette.primary,
        },
        background: {
          default: palette.background,
          paper: palette.paper,
        },
      },
      typography: {
        fontFamily: Fonts.mono,
        button: {
          textTransform: 'none',
        },
      },
    });
  }, [scheme]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Header />
        <Switch>
          <Route exact path="/:name" component={PadPage} />
          <Route exact path="/index.html" component={HomePage} />
          <Route exact path="/" component={HomePage} />
          <Route path="/" component={Page404} />
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
